import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';
import { CognitoAuthService } from '../services/cognitoAuth.service';
import { ItonicsAuthService } from '../services/itonicsAuth.service';

/*@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public auth:AuthService){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.auth.isAuthenticated();
  }
}*/

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private itonicsAuthService: ItonicsAuthService, private cognitoAuthService: CognitoAuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    // code for signup app
    const isSignUp = this.cognitoAuthService.parseAuthResponseFromCognito(next.fragment);
    if (isSignUp) {
      return false;
    }

    // code for tenant app
    const isSet = this.itonicsAuthService.setAuthSessionFromUrlIfExists(next.queryParams);
    if (isSet) {
      // remove hash
      this.router.navigate(['/home']);
      return false;
    }

    return new Promise((resolve) => {
      this.itonicsAuthService.isAuthenticated({
        isLoggedIn: (message, loggedIn) => {
          if (!loggedIn) {
            // redirect to login page
            this.router.navigate(['/login']);
            resolve(false);
          } else {
            resolve(true);
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts